import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import tops from './components/top.vue'
Vue.component("DivTop", tops)
import footer from './components/footer.vue'
Vue.component("Divfooter", footer)
Vue.config.productionTip = false
import less from 'less'
import VueParticles from "vue-particles";
Vue.use(VueParticles)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(less)
import * as echarts from 'echarts'
import './request/china.js'
Vue.prototype.$echarts = echarts
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import Axios from 'axios'
Vue.prototype.axios = Axios
import {MethodPost} from './request/axios.js'
Vue.prototype.MethodPost=MethodPost
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

